import React from 'react';

function Project(props){
  return(
    <div className="project">
      <a href={props.link}>
        <h2>{props.title}</h2>
        <img src={props.image} alt={props.title+" toy screenshot"} />
        <p>{props.description}</p>
      </a>
    </div>
  );
}
export default Project;
